import ListingDetailsFields, { listingPayload } from "./ListingDetailsFields";
import "../styles/ListingDetailsFields.css";
import React, { useEffect, useState } from "react";
import api from "../api";
import { useNavigate, useParams } from "react-router-dom";
import "../styles/PropertyList.css"; // reuse cozy card styles

const asArray = (payload) =>
  Array.isArray(payload)
    ? payload
    : Array.isArray(payload?.data)
    ? payload.data
    : Array.isArray(payload?.items)
    ? payload.items
    : Array.isArray(payload?.results)
    ? payload.results
    : [];

export default function EditProperty() {
  const navigate = useNavigate();
  const { id } = useParams();
  const [listingDetails, setListingDetails] = useState({});
  const [properties, setProperties] = useState([]);
  const [selectedId, setSelectedId] = useState(id || "");
  const [unitData, setUnitData] = useState({
    propertyName: "",
    location: "",
    rentPrice: "",
    latitude: "",
    longitude: "",
    description: "",
    tenantName: "",
    isOccupied: false,
  });
  const [toast, setToast] = useState(null);

  // Fetch all properties
  useEffect(() => {
    const fetchProperties = async () => {
      try {
        const res = await api.get("/rental-properties", {
          headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
        });
        const mapped = asArray(res.data).map((p) => ({
          ...p,
          isOccupied: Boolean(p.is_occupied),
        }));
        setProperties(mapped);
      } catch (err) {
        console.error(err);
        setToast({ message: "Failed to fetch properties.", type: "error" });
        setTimeout(() => setToast(null), 4000);
      }
    };
    fetchProperties();
  }, []);

  // Populate form when property selected
  useEffect(() => {
    if (!selectedId) return;
    const prop = properties.find((p) => p.id === Number(selectedId));
    if (prop) {
      setListingDetails(prop.listing_details || {});
      setUnitData({
        propertyName: prop.property_name,
        location: prop.location,
        rentPrice: prop.rent_price,
        latitude: prop.latitude,
        longitude: prop.longitude,
        description: prop.description,
        tenantName: prop.tenant_name || "",
        isOccupied: prop.isOccupied,
      });
    }
  }, [selectedId, properties]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setUnitData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!selectedId) return;

    try {
      await api.put(`/rental-properties/${selectedId}`, {
        listing_details: listingPayload(listingDetails),
        property_name: unitData.propertyName,
        location: unitData.location,
        rent_price: Number(unitData.rentPrice),
        latitude: unitData.latitude === "" || unitData.latitude == null ? null : Number(unitData.latitude),
        longitude: unitData.longitude === "" || unitData.longitude == null ? null : Number(unitData.longitude),
        description: unitData.description,
        tenant_name: unitData.tenantName || null,
        is_occupied: unitData.isOccupied,
      }, {
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
      });

      setToast({ message: "Property updated successfully!", type: "success" });
      setTimeout(() => setToast(null), 4000);
      setTimeout(() => navigate("/list-properties"), 2000);
    } catch (err) {
      console.error(err);
      setToast({ message: "Failed to update property.", type: "error" });
      setTimeout(() => setToast(null), 4000);
    }
  };

  return (
    <div className="propertylist-page cozy-background">
      <div className="propertylist-card">
        <button className="home-btn" onClick={() => navigate("/home")}>🏠 Home</button>
        <h2 className="propertylist-title">Edit Property</h2>

        <div className="form-group">
          <label htmlFor="editproperty-field-1">Select Property</label>
          <select id="editproperty-field-1" value={selectedId} onChange={(e) => setSelectedId(e.target.value)}>
            <option value="">-- Choose a property --</option>
            {properties.map((p) => (
              <option key={p.id} value={p.id}>{p.property_name}</option>
            ))}
          </select>
        </div>

        {selectedId && (
          <form className="edit-form" onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="editproperty-field-2">Property Name</label>
              <input id="editproperty-field-2"
                type="text"
                name="propertyName"
                value={unitData.propertyName}
                onChange={handleChange}
                required
              />
            </div>

            <div className="form-group">
              <label htmlFor="editproperty-field-3">Location</label>
              <input id="editproperty-field-3"
                type="text"
                name="location"
                value={unitData.location}
                onChange={handleChange}
                required
              />
            </div>

            <div className="form-group">
              <label htmlFor="editproperty-field-4">Rent Price</label>
              <input id="editproperty-field-4"
                type="number"
                name="rentPrice"
                value={unitData.rentPrice}
                onChange={handleChange}
                required
              />
            </div>

            <div className="double-inputs">
              <div className="form-group">
                <label htmlFor="editproperty-field-5">Latitude</label>
                <input id="editproperty-field-5"
                  type="number" step="any"
                  name="latitude"
                  value={unitData.latitude}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="form-group">
                <label htmlFor="editproperty-field-6">Longitude</label>
                <input id="editproperty-field-6"
                  type="number" step="any"
                  name="longitude"
                  value={unitData.longitude}
                  onChange={handleChange}
                  required
                />
              </div>
            </div>

            <div className="form-group">
              <label htmlFor="editproperty-field-7">Description</label>
              <textarea id="editproperty-field-7"
                name="description"
                value={unitData.description}
                onChange={handleChange}
                required
              />
            </div>

            <div className="form-group">
              <label>
                <input
                  type="checkbox"
                  name="isOccupied"
                  checked={unitData.isOccupied}
                  onChange={handleChange}
                /> Occupied
              </label>
            </div>

            <ListingDetailsFields value={listingDetails} onChange={setListingDetails} />
            <button type="submit" className="save-btn">💾 Save Changes</button>
          </form>
        )}

        {toast && (
          <div className={`toast-box ${toast.type}`}>
            {toast.type === "success" ? "✅ " : "❌ "} {toast.message}
          </div>
        )}
      </div>
    </div>
  );
}
